import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

import flagIcon from 'app/icons/flag_arbitrage.svg';
import Icon from 'app/components/Icon';
import Dropdown from 'app/components/Dropdown';

import style from './style.scss';

interface Props {
  withTooltip?: boolean;
  size?: 'normal' | 'small';
  className?: string;
}

const ArbitrageIcon: FC<Props> = ({ withTooltip = false, size = 'normal', className }) => {
  const [t] = useTranslation();

  const squareClassName = classNames(
    style.square,
    { [style.square_small]: size === 'small' },
    className
  );

  if (withTooltip) {
    return (
      <Dropdown
        className={squareClassName}
        withArrow
        label={<Icon href={flagIcon} className={style.icon} />}
        width={200}
        withIcon={false}
        alignment="middle"
        position="top"
        offset={{ x: 0, y: 15 }}
        portalClassName={style.portal}
      >
        <div className={style.tooltip}>{t('match_market-arbitrage-situation')}</div>
      </Dropdown>
    );
  }

  return (
    <div className={squareClassName}>
      <Icon href={flagIcon} className={style.icon} />
    </div>
  );
};

ArbitrageIcon.displayName = 'ArbitrageIcon';

export default ArbitrageIcon;
